import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { format, parseISO } from 'date-fns';
import { Dictionary } from 'lodash';
import { BehaviorSubject, Observable, map } from 'rxjs';
import {
  iBirthdayResponse,
  iEmpConfidentialDetailsLogsResponse,
  iEmployeeConfidentialDetails,
  iEmployeeGet,
  iEmployeeHierarchy,
  iEmployeeHierarchyResponse,
  iEmployeeResult,
  iEmployeeResultDto,
  iEmployeeTaskFiltration,
  iEmployeeUsernameDto,
  iExportEmpReqDto,
} from 'src/app/helpers/Interfaces/employee';
import {
  iPaginationRequest,
  iPaginationResult,
} from 'src/app/helpers/Interfaces/pagination';
import { iTaskReq } from 'src/app/helpers/Interfaces/task';
import { int } from 'src/app/helpers/Types/types';
import { DataService } from 'src/app/helpers/data.service';
import { environment } from 'src/environments/environment.development';

@Injectable({
  providedIn: 'root',
})
export class EmployeeService {
  private readonly _getEmployeeByUserId = `${environment.base_url}/api/Employee/GetByUserId`;
  private readonly _getEmployeeByStationId = `${environment.base_url}/api/Employee/GetEmpDataByStation`;
  private readonly _getEmployeeById = `${environment.base_url}/api/Employee/GetById`;
  private readonly _getAllEmployees = `${environment.base_url}/api/Employee/GetAll`;
  // private readonly _exportEmployeesData = `${environment.base_url}/api/Employee/ExportEmployeesData`;
  private readonly _exportEmployeesData = `${environment.base_url}/api/employee/exportemployeesdataenhanced`;
  // private readonly _getEmployees = `${environment.base_url}/api/Employee/Get`;
  private readonly _getEmployees = `${environment.base_url}/api/Employee/GetAll`;
  private readonly _getAllEmployeesWithFiltration = `${environment.base_url}/api/Employee/GetAllWithFilteration`;
  private readonly _getProfile = `${environment.base_url}/api/Employee/GetProfile`;
  private readonly _addEmployee = `${environment.base_url}/api/Employee/Add`;
  private readonly _updateEmployee = `${environment.base_url}/api/Employee/Update`;
  private readonly _removeEmployee = `${environment.base_url}/api/Employee/Remove`;
  private readonly _changeStatus = `${environment.base_url}/api/Employee/ChangeStatus`;
  private readonly _getAllUsername = `${environment.base_url}/api/Employee/GetAllUsername`;
  private readonly _updatedEmployeeSetting = `${environment.base_url}/api/Employee/UpdateEnployeeSetting`;
  private readonly _employeeRejoin = `${environment.base_url}/api/employee/rejoin`;
  private readonly _getEmployeeSetting = `${environment.base_url}/api/Employee/GetEmployeeSetting`;
  private readonly _statusHubUrl = `${environment.base_url}/statusHub`;

  private readonly _getEmploymentInformationByEmployee = `${environment.base_url}/api/EmployeementInformation/GetByEmployeeId`;
  private readonly _addEmploymentInformation = `${environment.base_url}/api/EmployeementInformation/Add`;
  private readonly _updateEmploymentInformation = `${environment.base_url}/api/EmployeementInformation/Update`;

  private readonly _getPersonalInformationByEmployee = `${environment.base_url}/api/EmployeePersonalInformation/GetByEmployeeId`;
  private readonly _addPersonalInformation = `${environment.base_url}/api/EmployeePersonalInformation/Add`;
  private readonly _updatePersonalInformation = `${environment.base_url}/api/EmployeePersonalInformation/Update`;

  private readonly _getOfficialContactByEmployee = `${environment.base_url}/api/EmployeeOfficialContact/GetByEmployeeId`;
  private readonly _addOfficialContact = `${environment.base_url}/api/EmployeeOfficialContact/Add`;
  private readonly _updateOfficialContact = `${environment.base_url}/api/EmployeeOfficialContact/Update`;

  private readonly _getEmergencyContactByEmployee = `${environment.base_url}/api/EmployeeEmergencyContact/GetByEmployeeId`;
  private readonly _addEmergencyContact = `${environment.base_url}/api/EmployeeEmergencyContact/Add`;
  private readonly _updateEmergencyContact = `${environment.base_url}/api/EmployeeEmergencyContact/Update`;

  private readonly _getBankInfoByEmployee = `${environment.base_url}/api/EmployeeBankInformation/GetByEmployeeId`;
  private readonly _addBankInfo = `${environment.base_url}/api/EmployeeBankInformation/Add`;
  private readonly _updateBankInfo = `${environment.base_url}/api/EmployeeBankInformation/Update`;

  private readonly _getPersonalContactInfoByEmployee = `${environment.base_url}/api/EmployeePersonalContactInformation/GetByEmployeeId`;
  private readonly _addPersonalContactInfo = `${environment.base_url}/api/EmployeePersonalContactInformation/Add`;
  private readonly _updatePersonalContactInfo = `${environment.base_url}/api/EmployeePersonalContactInformation/Update`;

  private readonly _getDocumentsByEmployee = `${environment.base_url}/api/EmployeeDocuments/GetByEmployeeId`;
  private readonly _getEmployeeDocumentsByEmployeeId = `${environment.base_url}/api/employeedocuments/getbyemployeeid`;
  private readonly _addEmployeeDocument = `${environment.base_url}/api/employeedocuments/add`;
  private readonly _addDocuments = `${environment.base_url}/api/EmployeeDocuments/Add`;
  private readonly _updateDocuments = `${environment.base_url}/api/EmployeeDocuments/Update`;

  private readonly _employeeSkills = `${environment.base_url}/api/employeeskill/getbyemployee`;
  private readonly _getQualificationByEmployee = `${environment.base_url}/api/employeequalification/getbyemployee`;
  private readonly _addQualification = `${environment.base_url}/api/employeequalification/create`;
  private readonly _updateQualification = `${environment.base_url}/api/employeequalification/update`;
  private readonly _removeQualification = `${environment.base_url}/api/employeequalification/remove`;

  private readonly _permanentDelete = `${environment.base_url}/api/Employee/PermanentDelete`;
  private readonly _changeShift = `${environment.base_url}/api/Employee/ChangeShift`;
  private readonly _changeHour = `${environment.base_url}/api/Employee/ChangeHour`;
  private readonly _getEmployeeHierarchy = `${environment.base_url}/api/Employee/GetHierarchy`;

  private readonly _empConfidentialDetailsLogsGetByEmployeeId = `${environment.base_url}/api/EmpConfidentialDetailsLogs/GetByEmployeeId`;

  private readonly _getBirthdays = `${environment.base_url}/api/Employee/GetBirthdays`;
  private readonly _getEmpBirthday = `${environment.base_url}/api/Employee/GetEmpBirthday`;

  private readonly _getForTaskFiltration = `${environment.base_url}/api/Employee/GetEmployeeAndTaskCounts`;
  private readonly _getForTaskFiltrationByTeam = `${environment.base_url}/api/Employee/GetEmployeeAndTaskCountsByTeamId`;

  // Employee-Report
  private _getModuleForDashboar = `${environment.base_url}/api/ProjectAndEmployeeDashBoard/GetEmployeeWiseModuleSummary`;
  private _getProjectForDashboar = `${environment.base_url}/api/ProjectAndEmployeeDashBoard/GetEmployeeWiseProjectSummary`;
  private _getTask = `${environment.base_url}/api/ProjectAndEmployeeDashBoard/GetEmployeeWiseTaskSummary`;
  private _getFeatureForDashboar = `${environment.base_url}/api/ProjectAndEmployeeDashBoard/GetEmployeeWiseFeatureSummary`;
  private _getCounts = `${environment.base_url}/api/ProjectAndEmployeeDashBoard/EmployeeWiseCount`;
  private _getStatusWiseTaskCounts = `${environment.base_url}/api/ProjectAndEmployeeDashBoard/GetEmployeeStatusWiseTaskCount`;
  private _getStatusWiseTaskCountsWithDate = `${environment.base_url}/api/ProjectAndEmployeeDashBoard/GetEmployeeStatusAndMonthWiseTaskCount`;
  private _getProject = `${environment.base_url}/api/Project/GetAll`;
  private _getModule = `${environment.base_url}/api/Module/GetAll`;
  private _getFeature = `${environment.base_url}/api/Feature/GetAll`;
  private _getUserLinkedAccount = `${environment.base_url}/api/LinkedAccounts/GetByUserId`;
  private _getEmpAssets = `${environment.inventory_base_url}/api/AssetIssue/UserAssets`;

  public connection = new signalR.HubConnectionBuilder()
    .withUrl(this._statusHubUrl)
    .configureLogging(signalR.LogLevel.None)
    .build();

  private _userStatusSource: BehaviorSubject<{
    employeeId: string;
    status: int;
  }>;
  public userStatus$: Observable<{ employeeId: string; status: int }>;

  private _userStatusValue: { employeeId: string; status: int };
  public get userStatusValue(): { employeeId: string; status: int } {
    return this._userStatusValue;
  }
  public set userStatusValue(v: { employeeId: string; status: int }) {
    this._userStatusSource.next(v);
    this._userStatusValue = v;
  }
  workspaceId?: string;
  constructor(
    private _http: HttpClient,
    private _dataServ: DataService,
  ) {
    _dataServ.employee$.subscribe((emp) => {
      this.workspaceId = emp?.workspaceId;
    });
    this._userStatusSource = new BehaviorSubject<any>({
      employeeId: _dataServ.employeeValue?.id,
      status: _dataServ.employeeValue?.status,
    });
    this.userStatus$ = this._userStatusSource.asObservable();
    this._userStatusValue = this._userStatusSource.value;

    this.connection.onclose(async () => {
      await this.start();
    });
    this.connection.on('ReceiveData', (res: any) => {
      if (res.profilePic)
        res.profilePic = `${environment.base_url}/${res.profilePic}`;
      if (res.signIn) res.signIn = format(parseISO(res.signIn), 'HH:mm:ss a');
      if (res.signOut)
        res.signOut = format(parseISO(res.signOut), 'HH:mm:ss a');
      this._userStatusSource.next(res);
    });
  }
  public async start() {
    try {
      await this.connection.start();
    } catch (err) {
      console.warn(err);
      setTimeout(() => this.start(), 5000);
    }
  }

  GetEmployeeByUserId(userId: string) {
    return this._http.get<iEmployeeResult>(
      `${this._getEmployeeByUserId}?id=${userId}`,
      {
        responseType: 'json',
      },
    );
  }
  GetEmployeeByStationId(stationId: string) {
    return this._http.post<iEmployeeResult[]>(
      `${this._getEmployeeByStationId}?StationId=${stationId}`,
      null,
      {
        responseType: 'json',
      },
    );
  }
  GetEmployeeById(employeeId: string) {
    return this._http
      .get<any>(`${this._getEmployeeById}?id=${employeeId}`, {
        responseType: 'json',
      })
      .pipe(
        map((employee) => {
          employee.name = `${employee.firstName} ${employee.lastName}`;
          employee.profilePic = `${environment.base_url}/${employee.profilePic}`;
          if (employee.userName) {
            employee.username = employee.userName;
            delete employee.userName;
          }
          return employee;
        }),
      );
  }

  GetAllEmployees() {
    return this._http
      .get<iEmployeeResult[]>(this._getAllEmployees, {
        responseType: 'json',
      })
      .pipe(
        map((employees: iEmployeeResult[]) =>
          employees.map((emp) => {
            const employee: iEmployeeResultDto = {
              ...emp,
              name: null,
              Type: null,
            };
            // employee.Type = RoleTypes[employee.type];
            employee.name = `${employee.firstName} ${employee.lastName}`;
            employee.Type = employee.type;
            if (!employee.reportsToProfile?.includes(environment.base_url)) {
              employee.reportsToProfile = `${environment.base_url}/${employee.reportsToProfile}`;
            }
            if (!employee.profilePic?.includes(environment.base_url)) {
              employee.profilePic = `${environment.base_url}/${employee.profilePic}`;
            }
            return employee;
          }),
        ),
      );
  }
  GetAllUsernames(id?: string, options?: { headers?: HttpHeaders }) {
    let params = new HttpParams();

    if (id) {
      params = params.set('teamId', id);
    }

    return this._http
      .get<iEmployeeUsernameDto[]>(this._getAllUsername, {
        responseType: 'json',
        params,
        ...(options || {}),
      })
      .pipe(
        map((x) =>
          x.map((y) => {
            if (!y.profilePic?.includes(environment.base_url)) {
              y.profilePic = `${environment.base_url}/${y.profilePic}`;
            }
            return y;
          }),
        ),
      );
  }
  Get({
    IsActive,
    CompanyId,
    StationId,
    WorkspaceId,
    DesignationId,
    DepartmentId,
    FromDate,
    ToDate,
  }: {
    WorkspaceId: string;
    CompanyId: string;
    StationId: string;
    DepartmentId?: string;
    DesignationId?: string;
    IsActive?: boolean;
    FromDate?: any;
    ToDate?: any;
  }) {
    const params: any = {
      WorkspaceId,
      CompanyId,
      StationId,
      IsActive,
    };
    if (DepartmentId) params.DepartmentId = DepartmentId;
    if (DesignationId) params.DesignationId = DesignationId;
    if (FromDate) params.FromDate = FromDate;
    if (ToDate) params.ToDate = ToDate;
    if (params.IsActive !== undefined) params.IsActive = params.IsActive;

    return this._http
      .post<iEmployeeGet[]>(`${this._getEmployees}`, [], {
        params,
        responseType: 'json',
      })
      .pipe(
        map((x) =>
          x.map((y) => {
            if (!y.profilePic?.includes(environment.base_url)) {
              y.profilePic = `${environment.base_url}/${y.profilePic}`;
            }
            return y;
          }),
        ),
      );
  }
  getForTaskFiltration(dto: iTaskReq) {
    return this._http
      .post<iEmployeeTaskFiltration[]>(this._getForTaskFiltration, dto, {
        responseType: 'json',
      })
      .pipe(
        map((res) => {
          res.map((employee) => {
            employee.name = employee.firstName;
            if (employee.lastName) employee.name += ` ${employee.lastName}`;
            return employee;
          });
          return res;
        }),
      );
  }
  getForTaskFiltrationByTeam(id: string, dto: iTaskReq) {
    return this._http
      .post<iEmployeeTaskFiltration[]>(
        `${this._getForTaskFiltrationByTeam}/${id}`,
        dto,
        {
          responseType: 'json',
        },
      )
      .pipe(
        map((res) => {
          res.map((employee) => {
            employee.name = employee.firstName;
            if (employee.lastName) employee.name += ` ${employee.lastName}`;
            return employee;
          });
          return res;
        }),
      );
  }
  GetAllEmployeesWithFiltration(
    payload: iPaginationRequest,
    isProfile: boolean = false,
    companyId?: string,
    stationId?: string,
  ) {
    const updatedStation = stationId ? stationId : environment.emptyGuid;
    let headers = new HttpHeaders();
    if (companyId) headers = headers.set('CompanyId', companyId);
    if (updatedStation) headers = headers.set('StationId', updatedStation);

    return this._http
      .post<iPaginationResult<iEmployeeResult>>(
        `${isProfile ? this._getProfile : this._getAllEmployeesWithFiltration}`,
        payload,
        {
          responseType: 'json',
          headers,
        },
      )
      .pipe(
        map((res) => ({
          ...res,
          data: res.data.map((emp) => {
            const employee: iEmployeeResultDto = { ...emp };
            // employee.Type = RoleTypes[employee.type];
            employee.name = `${employee.firstName} ${employee.lastName}`;
            employee.Type = employee.type;
            if (!employee.reportsToProfile?.includes(environment.base_url)) {
              employee.reportsToProfile = `${environment.base_url}/${employee.reportsToProfile}`;
            }
            if (!employee.profilePic?.includes(environment.base_url)) {
              employee.profilePic = `${environment.base_url}/${employee.profilePic}`;
            }
            return employee;
          }),
        })),
      );
  }
  private createEmployeeFormDataPayload(data: any): FormData {
    const payload = new FormData();
    if (data.id) {
      payload.set('Id', data.id); // For updating
    }
    if (data.employeeId) {
      payload.set('Id', data.employeeId); // For updating
    }

    // isOverTimeAllowed: [false],
    //   lateDeduction: [false],
    //   absentDeduction: [false],
    //   eOBIDeduction: [false],
    //   attendanceAllowence: [false],
    //   isActive: [false],
    //   isResigned: [false],
    payload.set('FirstName', data.firstName);
    if (data.lastName) payload.set('LastName', data.lastName);
    payload.set('Email', data.email);
    payload.set('Contact', data.contact);
    if (data.shiftId) payload.set('ShiftId', data.shiftId);
    payload.set('EmpRoleId', data.empRoleId);
    if (
      data.type == false ||
      data.type == 'false' ||
      data.type == true ||
      data.type == 'true'
    )
      payload.set('Type', data.type);
    payload.set('WorkType', data.workType);
    payload.set('DataVisibility', data.dataVisibility);
    payload.set(
      'IsOverTimeAllowed',
      data.isOverTimeAllowed == undefined ? false : data.isOverTimeAllowed,
    );
    payload.set(
      'LateDeduction',
      data.lateDeduction == undefined ? false : data.lateDeduction,
    );
    payload.set(
      'AbsentDeduction',
      data.absentDeduction == undefined ? false : data.absentDeduction,
    );
    payload.set(
      'EOBIDeduction',
      data.eobiDeduction == undefined ? false : data.eobiDeduction,
    );
    payload.set(
      'AttendanceAllowence',
      data.attendanceAllowence == undefined ? false : data.attendanceAllowence,
    );
    payload.set('IsActive', data.isActive == undefined ? false : data.isActive);
    payload.set('Relaxation', data.relaxation || '0');
    payload.set(
      'IsResigned',
      data.isResigned == undefined ? false : data.isResigned,
    );
    payload.set(
      'IsExampted',
      data.isExampted == undefined ? false : data.isExampted,
    );
    payload.set('IsHourly', data.isHourly == undefined ? false : data.isHourly);
    payload.set(
      'IsMontlyHours',
      data.isMontlyHours == undefined ? false : data.isMontlyHours,
    );
    payload.set(
      'FileDeposit',
      data.fileDeposit == undefined ? false : data.fileDeposit,
    );
    payload.set('FileDepositDuration', String(data.fileDepositDuration ?? 0));

    payload.set(
      'HolidayIncentive',
      data.holidayIncentive == undefined ? false : data.holidayIncentive,
    );
    payload.set('HolidayIncentiveHours', data.holidayIncentiveHours || 0);
    payload.set('IsAssignee', String(data.IsAssignee ?? false));
    payload.set('WorkingHours', data.workingHours || 0);
    payload.set('Cost', data.cost || 0);
    if (data.designationId) payload.set('DesignationId', data.designationId);
    if (data.departmentId) payload.set('DepartmentId', data.departmentId);
    if (data.workspaceId) payload.set('WorkspaceId', data.workspaceId);
    if (data.companyId) payload.set('CompanyId', data.companyId);
    if (data.stationId) payload.set('StationId', data.stationId);
    payload.set('UserId', data.userId);
    if (data.machineId) payload.set('MachineId', data.machineId);
    if (data.reportsToId) payload.set('ReportsToId', data.reportsToId);
    if (data.isStartup) payload.set('IsStartup', data.isStartup);
    if (data.appraisalType) payload.set('AppraisalType', data.appraisalType);
    if (data.nextAppraisalDate)
      payload.set('NextAppraisalDate', data.nextAppraisalDate);

    return payload;
  }
  AddEmployee(data: any) {
    const payload = this.createEmployeeFormDataPayload(data);
    let headers = new HttpHeaders();
    if (data.companyId)
      headers = headers.set('CompanyId', environment.emptyGuid);
    if (data.stationId)
      headers = headers.set('StationId', environment.emptyGuid);
    //   if (profilePic) {
    //   payload.append('ProfilePic', profilePic);
    // }
    return this._http.post<any>(this._addEmployee, payload, {
      responseType: 'json',
      headers,
    });
  }
  UpdateEmployee(data: any, profilePic?: any) {
    const payload = this.createEmployeeFormDataPayload(data);
    let headers = new HttpHeaders();
    if (data.companyId)
      headers = headers.set('CompanyId', environment.emptyGuid);
    if (data.stationId)
      headers = headers.set('StationId', environment.emptyGuid);
    if (profilePic) {
      payload.append('ProfilePic', profilePic);
    }
    return this._http
      .put<any>(this._updateEmployee, payload, {
        responseType: 'json',
        headers,
      })
      .pipe(
        map((employee: any) => {
          // employee.Type = RoleTypes[employee.type];
          employee.Type = employee.type;
          return employee;
        }),
      );
  }
  DeleteEmployee(id: any) {
    return this._http.delete(`${this._removeEmployee}?id=${id}`);
  }
  ChangeStatus(payload: { employeeId: string; status: int }) {
    return this._http.put<{ employeeId: string; status: int }>(
      this._changeStatus,
      payload,
      {
        responseType: 'json',
      },
    );
  }
  updatedEmployeeSetting(payload: iEmployeeConfidentialDetails) {
    return this._http.put(this._updatedEmployeeSetting, payload, {
      responseType: 'json',
    });
  }
  rejoin(employeeId: string) {
    return this._http.post(`${this._employeeRejoin}/${employeeId}`, null, {
      responseType: 'json',
    });
  }
  getEmployeeSetting(id: string) {
    return this._http.get<iEmployeeConfidentialDetails>(
      this._getEmployeeSetting,
      {
        params: { id },
        responseType: 'json',
      },
    );
  }

  GetEmploymentInformationByEmployee(id: string) {
    return this._http.get<any>(
      `${this._getEmploymentInformationByEmployee}?id=${id}`,
      { responseType: 'json' },
    );
  }
  AddEmploymentInformation(payload: any) {
    return this._http.post<any>(`${this._addEmploymentInformation}`, payload, {
      responseType: 'json',
    });
  }
  UpdateEmploymentInformation(payload: any) {
    return this._http.put<any>(
      `${this._updateEmploymentInformation}`,
      payload,
      {
        responseType: 'json',
      },
    );
  }

  GetPersonalInformationByEmployee(id: string) {
    return this._http.get<any>(
      `${this._getPersonalInformationByEmployee}?id=${id}`,
      { responseType: 'json' },
    );
  }
  AddPersonalInformation(payload: any) {
    return this._http.post<any>(`${this._addPersonalInformation}`, payload, {
      responseType: 'json',
    });
  }
  UpdatePersonalInformation(payload: any) {
    return this._http.put<any>(`${this._updatePersonalInformation}`, payload, {
      responseType: 'json',
    });
  }

  GetOfficialContactByEmployee(id: string) {
    return this._http.get<any>(
      `${this._getOfficialContactByEmployee}?id=${id}`,
      { responseType: 'json' },
    );
  }
  AddOfficialContact(payload: any) {
    return this._http.post<any>(`${this._addOfficialContact}`, payload, {
      responseType: 'json',
    });
  }
  UpdateOfficialContact(payload: any) {
    return this._http.put<any>(`${this._updateOfficialContact}`, payload, {
      responseType: 'json',
    });
  }

  GetEmergencyContactByEmployee(id: string) {
    return this._http.get<any>(
      `${this._getEmergencyContactByEmployee}?id=${id}`,
      { responseType: 'json' },
    );
  }
  AddEmergencyContact(payload: any) {
    return this._http.post<any>(`${this._addEmergencyContact}`, payload, {
      responseType: 'json',
    });
  }
  UpdateEmergencyContact(payload: any) {
    return this._http.put<any>(`${this._updateEmergencyContact}`, payload, {
      responseType: 'json',
    });
  }

  GetBankInfoByEmployee(id: string) {
    return this._http.get<any>(`${this._getBankInfoByEmployee}?id=${id}`, {
      responseType: 'json',
    });
  }
  AddBankInfo(payload: any) {
    return this._http.post<any>(`${this._addBankInfo}`, payload, {
      responseType: 'json',
    });
  }
  UpdateBankInfo(payload: any) {
    return this._http.put<any>(`${this._updateBankInfo}`, payload, {
      responseType: 'json',
    });
  }

  GetPersonalContactInfoByEmployee(id: string) {
    return this._http.get<any>(
      `${this._getPersonalContactInfoByEmployee}?id=${id}`,
      {
        responseType: 'json',
      },
    );
  }
  AddPersonalContactInfo(payload: any) {
    return this._http.post<any>(`${this._addPersonalContactInfo}`, payload, {
      responseType: 'json',
    });
  }
  UpdatePersonalContactInfo(payload: any) {
    return this._http.put<any>(`${this._updatePersonalContactInfo}`, payload, {
      responseType: 'json',
    });
  }

  GetDocumentsByEmployee(id: string) {
    return this._http.get<any[]>(`${this._getDocumentsByEmployee}?id=${id}`, {
      responseType: 'json',
    });
  }
  GetEmployeeDocumentsByEmployeeId(id: string) {
    return this._http.get<any[]>(`${this._getEmployeeDocumentsByEmployeeId}`, {
      params: { id },
      responseType: 'json',
    });
  }
  AddEmployeeDocument(payload: FormData) {
    let headers = new HttpHeaders();
    const companyId = this._dataServ.companyIdValue;
    const stationId = this._dataServ.stationIdValue;
    const workspaceId = this._dataServ.employeeValue?.workspaceId;

    if (companyId) headers = headers.set('CompanyId', companyId);
    if (stationId) headers = headers.set('StationId', stationId);
    if (workspaceId) headers = headers.set('WorkspaceId', workspaceId);

    return this._http.post<any>(`${this._addEmployeeDocument}`, payload, {
      responseType: 'json',
      headers,
    });
  }
  AddDocuments(payload: FormData) {
    return this._http.post<any>(`${this._addDocuments}`, payload, {
      responseType: 'json',
      // headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }),
    });
  }
  UpdateDocuments(payload: any) {
    return this._http.put<any>(`${this._updateDocuments}`, payload, {
      responseType: 'json',
    });
  }
  GetEmployeeSkills(employeeId: string) {
    return this._http
      .get<any>(`${this._employeeSkills}?employeeId=${employeeId}`, {
        responseType: 'json',
      })
      .pipe(map((res) => res?.data?.[0]?.skills || []));
  }
  permanentDelete(id: string) {
    return this._http.delete(`${this._permanentDelete}?Id=${id}`);
  }
  exportEmployeesData(payload: iExportEmpReqDto) {
    return this._http.post(`${this._exportEmployeesData}`, payload, {
      responseType: 'arraybuffer',
    });
  }
  changeShift(employeeIds: string[], shiftId: string) {
    return this._http.put(
      `${this._changeShift}?ShiftId=${shiftId}`,
      employeeIds,
      { responseType: 'json' },
    );
  }
  changeHour(employeeIds: string[], hours: number) {
    return this._http.put(`${this._changeHour}?hours=${hours}`, employeeIds, {
      responseType: 'json',
    });
  }
  getEmployeeHierarchy() {
    const params: Dictionary<string> = {};
    if (this.workspaceId) params['WorkspaceId'] = this.workspaceId;
    return this._http
      .get<iEmployeeHierarchyResponse[]>(`${this._getEmployeeHierarchy}`, {
        params,
        responseType: 'json',
      })
      .pipe(
        map(
          (x) =>
            [
              {
                name: '',
                designation: '',
                profilePic: '/favicon.ico',
                contact: '',
                department: '',
                email: '',
                id: 'bd',
                reportsToId: '',
              },
              ...x.map((y) => ({
                ...y,
                reportsToId: y.reportsToId ?? 'bd',
                profilePic: y.profilePic
                  ? `${environment.base_url}/${y.profilePic}`
                  : '/assets/images/avatars/0.png',
                designation: y.designation || '---',
              })),
            ] as iEmployeeHierarchy[],
        ),
      );
  }

  empConfidentialDetailsLogsGetByEmployeeId(
    pageNumber: number,
    employeeId: string,
  ) {
    return this._http
      .post<iPaginationResult<iEmpConfidentialDetailsLogsResponse>>(
        this._empConfidentialDetailsLogsGetByEmployeeId,
        {
          pageNumber,
          pageSize: 10,
          sortingParams: {
            EmployeeId: employeeId,
          },
        },
      )
      .pipe(
        map((res) => ({
          ...res,
          data: res.data.map((r) => ({
            ...r,
            cd: format(r.createdDate || Date.now(), 'dd-MM-yyyy p'),
          })),
        })),
      );
  }

  getBirthdays() {
    return this._http
      .get<iBirthdayResponse[]>(`${this._getBirthdays}`, {
        responseType: 'json',
      })
      .pipe(
        map((res) =>
          res.map((b) => ({
            ...b,
            profilePic: `${environment.base_url}/${b.profilePic}`,
          })),
        ),
      );
  }

  public GetEmployeeBirthday(employeeId: string) {
    let params = new HttpParams();
    if (employeeId) {
      params = params.set('EmpId', employeeId);
    }
    return this._http.get<any>(this._getEmpBirthday, {
      params,
    });
  }

  // Employee-report
  public GetEmployeeWiseModuleSummary(employeeId: string) {
    return this._http.post<any>(this._getModuleForDashboar, null, {
      params: { employeeId },
    });
  }

  public GetProjectSummary(employeeId: string) {
    return this._http.post<any>(this._getProjectForDashboar, null, {
      params: { employeeId },
    });
  }

  public GetTaskSummary(employeeId: string) {
    return this._http.post<any>(this._getTask, null, {
      params: { employeeId },
    });
  }

  public GetFeatureSummary(employeeId: string) {
    return this._http.post<any>(this._getFeatureForDashboar, null, {
      params: { employeeId },
    });
  }

  public GetEmployeeCounts(params: {
    employeeId: string;
    ModuleId?: string;
    FeatureId?: string;
  }) {
    return this._http.post<any>(this._getCounts, null, { params });
  }

  public GetStatusWiseTaskCounts(params: {
    employeeId: string;
    ModuleId?: string;
    FeatureId?: string;
  }) {
    return this._http.post<any>(this._getStatusWiseTaskCounts, null, {
      params,
    });
  }

  public GetStatusWiseTaskCountsWithDateRange(params: {
    year: string;
    employeeId: string;
    ModuleId?: string;
    FeatureId?: string;
  }) {
    return this._http.post<any>(this._getStatusWiseTaskCountsWithDate, null, {
      params,
    });
  }

  public GetUserLinkedAccount(userId: string) {
    return this._http.get<any>(this._getUserLinkedAccount, {
      responseType: 'json',
      params: { userId },
    });
  }

  public GetEmpAssets(userId: string) {
    return this._http.get<any>(`${this._getEmpAssets}/${userId}`, {
      responseType: 'json',
    });
  }

  GetProject(): Observable<any[]> {
    return this._http.get<any[]>(this._getProject);
  }

  GetModule(): Observable<any[]> {
    return this._http.get<any[]>(this._getModule);
  }

  GetFeature(): Observable<any[]> {
    return this._http.get<any[]>(this._getFeature);
  }

  GetQualificationByEmployee(employeeId: string) {
    return this._http.get<any>(
      `${this._getQualificationByEmployee}?employeeId=${employeeId}`,
      {
        responseType: 'json',
      },
    );
  }
  AddQualification(payload: any) {
    return this._http.post<any>(`${this._addQualification}`, payload, {
      responseType: 'json',
    });
  }
  UpdateQualification(payload: any) {
    return this._http.put<any>(`${this._updateQualification}`, payload, {
      responseType: 'json',
    });
  }
  RemoveQualification(id: string) {
    return this._http.delete(`${this._removeQualification}?id=${id}`);
  }
}
